@if (toggleType() === 'button') {
  <ts-button
    type="stroked"
    color="accent"
    class="xs:hidden"
    icon="visibility"
    [matTooltip]="singleSelect() ? 'Select field' : 'Select columns'"
    [tsOverlayTriggerFor]="columnsSelectOverlayBox"
    [disabled]="disabled()"
  >
    <ng-content></ng-content>
  </ts-button>
} @else {
  <ts-button
    type="icon"
    color="basic"
    icon="visibility"
    [matTooltip]="singleSelect() ? 'Select field' : 'Select columns'"
    [tsOverlayTriggerFor]="columnsSelectOverlayBox"
    [disabled]="disabled()"
  >
  </ts-button>
}

<ts-overlay
  #columnsSelectOverlayBox
  position="bottom"
  [transparentBackdrop]="true"
  (closeByBackdropClick)="onColumnSelectClosedByBackdropClick()"
>
  @defer {
    <div class="new-field-selection">
      <div class="new-field-selection__search">
        <mat-icon>search</mat-icon>
        <input
          type="text"
          placeholder="Enter field name"
          maxLength="50"
          [formControl]="fieldInput"
          #fieldInputElement
        />
        <mat-icon class="clear-icon" [class.invisible]="!fieldInputElement.value" (click)="fieldInput.setValue('')"
          >cancel</mat-icon
        >
        <input type="hidden" [formControl]="onlySelected" />
        <mat-icon
          class="only-selected"
          [class.on]="onlySelected.value"
          matTooltip="Filter only selected"
          matTooltipPosition="right"
          matTooltipShowDelay="250"
          (click)="onlySelected.setValue(!onlySelected.value)"
          >check_circle_outline</mat-icon
        >
      </div>
      <div class="new-field-selection__fields">
        @for (
          field of fieldDefs$
            | async
            | tsFilterBy
              : []
              : {
                  relatedTo: relatedTo(),
                  query: fieldInputValue | async,
                  onlySelected: onlySelectedValue | async,
                  nestedOn: overrideNestedOnValue() === undefined ? (nestedOn$ | async) : overrideNestedOnValue(),
                  columns: selectedColumns(),
                }
              : ownTypeFilterFn;
          track field
        ) {
          <ng-container
            *ngTemplateOutlet="
              fieldItem;
              context: {
                $implicit: {
                  cssClass: 'new-field-selection__fields__field',
                  item: field,
                  fieldInputElement: fieldInputElement,
                },
              }
            "
          />
        }
        @for (
          field of fieldDefs$
            | async
            | tsFilterBy
              : []
              : {
                  relatedTo: relatedTo(),
                  query: fieldInputValue | async,
                  onlySelected: onlySelectedValue | async,
                  nestedOn: overrideNestedOnValue(),
                  columns: selectedColumns(),
                }
              : relatedTypeFilterFn
            | groupBy: '_parentFieldName' : '_parentFieldLabel';
          track field
        ) {
          <div class="new-field-selection__fields__section">
            <p class="new-field-selection__fields__section__title" (click)="toggleExpand(field.groupName)">
              <mat-icon>{{
                expanded().includes(field.groupName) ? 'keyboard_arrow_down' : 'keyboard_arrow_right'
              }}</mat-icon>
              <span>{{ field.groupLabel }}</span>
              @if (
                { items: field.items, selectedItems: selectedColumns() } | tsMutateToAny: countByType;
                as badgeData
              ) {
                <ts-badge
                  [value]="badgeData.label"
                  [type]="badgeData.hasSelected ? 'info' : 'orange'"
                  [floating]="false"
                  [class.invisible]="badgeData.label === '0'"
                ></ts-badge>
              }
            </p>
            @if (expanded().includes(field.groupName)) {
              <div class="new-field-selection__fields__section__items">
                @for (item of field.items; track $index) {
                  <ng-container
                    *ngTemplateOutlet="
                      fieldItem;
                      context: {
                        $implicit: {
                          cssClass: 'new-field-selection__fields__section__items__item',
                          item: item,
                          fieldInputElement: fieldInputElement,
                        },
                      }
                    "
                  />
                }
              </div>
            }
          </div>
        }
        @if (!hasMatch()) {
          <p class="new-field-selection__fields__empty">
            <mat-icon>error_outline</mat-icon> No results for <strong>{{ fieldInputElement.value }}</strong>
          </p>
        }
      </div>
    </div>
  }
</ts-overlay>

<ng-template #fieldItem let-fieldItem>
  <span
    [class]="fieldItem.cssClass"
    (click)="toggleDisplayColumn(fieldItem.item.name)"
    [class.selected]="selectedColumns().includes(fieldItem.item.name)"
  >
    <mat-icon [class.invisible]="!selectedColumns().includes(fieldItem.item.name)">check_circle_outline</mat-icon>
    <span [innerHtml]="fieldItem.item.label | highlighter: fieldItem.fieldInputElement.value : '' : 'partial'"> </span>
  </span>
</ng-template>
